export default __webpack_public_path__ + "static/media/sbr_bank.8c8179dd.svg";